import { WorkDayRequest } from ".";

export class WorkDaysRequest {
  constructor(workDaysFormValues = {}) {
    this.work_days = workDaysFormValues.map(day => new WorkDayRequest(day));
  }
}
